const TZ_BR = "America/Sao_Paulo";

/**
 * Interpreta valores da API como UTC (MySQL/EF costuma omitir o sufixo Z).
 */
export function parseApiDate(value) {
  if (value == null || value === "") return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const hasTz = /[zZ]|[+-]\d{2}:\d{2}$/.test(raw);
  const iso = hasTz ? raw : `${raw.replace(/\.\d+$/, "")}Z`;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTimeBr(value, options = {}) {
  const d = parseApiDate(value);
  if (!d) return "-";

  return d.toLocaleString("pt-BR", {
    timeZone: TZ_BR,
    ...options,
  });
}

export function formatDateBr(value) {
  const d = parseApiDate(value);
  if (!d) return "-";

  return d.toLocaleDateString("pt-BR", { timeZone: TZ_BR });
}
